import Image from "next/image";
import {
  Check,
  ArrowRight,
  MapPin,
  Truck,
  UtensilsCrossed,
  Clock3,
  Users,
} from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";
import FranceMap from "./FranceMap";

export default function Solutions({ data }: BlockProps) {
  if (!data) return null;

  const imageUrl = data?.image?.url;
  const solutions = data?.solutions || [];
  const solutionIcons = [UtensilsCrossed, Clock3, Users, Truck];

  return (
    <section
      className="relative overflow-hidden bg-violet-light py-10 lg:py-20"
      key={data.id}
    >
      {/* Décors */}
      <div className="absolute -left-16 top-10 hidden h-60 w-60 rounded-full bg-yellow lg:block" />
      <div className="absolute -right-14 top-1/3 hidden h-44 w-44 rounded-full bg-pink lg:block" />

      <div className="container relative z-10">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          {/* Partie gauche */}
          <div>


            <h2 className="max-w-[820px] font-literata text-[32px] font-bold leading-[1.3] text-text-body md:text-[44px] lg:text-[58px]">
              {data.titre}
            </h2>

            <div className="mt-6 max-w-[860px] space-y-4 text-[18px] leading-[1.45] text-text-body md:text-[22px]">
              {typeof data.description === "string" ? (
                <p>{data.description}</p>
              ) : (
                data.description
              )}
            </div>

            <div className="mt-8 flex items-center gap-3">

              <p className="font-body text-[22px] font-semibold leading-[1.3] text-text-body md:text-[28px]">
                {data.titreSolutions}
              </p>
            </div>

            {/* Liste verticale des solutions */}
            <div className="mt-8 space-y-4">
              {solutions.map((item: any, index: number) => (
                <div
                  key={item.id || index}
                  className="group flex items-center gap-4 rounded-[24px] bg-white px-5 py-4 shadow-[0_10px_30px_rgba(0,0,0,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(221,34,96,0.15)]"
                >
                  {(() => {
                    const FallbackIcon = solutionIcons[index % solutionIcons.length];

                    return (
                      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-pink text-white shadow-[0_10px_20px_rgba(221,34,96,0.18)]">
                        {item.icon?.url ? (
                          <div className="relative h-7 w-7">
                            <Image
                              src={item.icon.url}
                              alt={item.icon.alternativeText || item.text || "Icône"}
                              fill
                              className="object-contain"
                            />
                          </div>
                        ) : (
                          <FallbackIcon className="h-7 w-7" />
                        )}
                      </div>
                    );
                  })()}


                  <p className="font-body text-[18px] font-semibold leading-[1.25] text-text-body md:text-[22px]">
                    {item.text}
                  </p>
                </div>


              ))}
            </div>

            {/* Conclusion */}
            {data.conclusion && (


              <p className="font-literata text-[22px] pt-8 font-bold leading-[1.35] text-text-body md:text-[32px]">
                {data.conclusion}
              </p>

            )}
          </div>
          {/* Partie droite */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative w-full ">
              {imageUrl && (
                
                  <div className="relative aspect-4/5 w-full">
                    <Image
                      src={imageUrl}
                      alt={data.image?.alternativeText || data.titre}
                      fill
                      className="rounded-[28px] object-cover"
                    />
                  </div>
               
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}